import React from "react";
import {Avatar, Card, Col, Row, Typography} from "antd";
import {ImageUtils} from "../../services/utils/ImageUtils";
import {RouteComponentProps} from "react-router-dom";
import {StudentDetailsDto} from "../../services/api/CoreApiClient";
import {observer} from "mobx-react";
import {StudentDetailsScene} from "../../scenes/authorized/Students/StudentDetailsScene";
import {computed} from "mobx";
import {AuditOutlined, FieldNumberOutlined, PhoneOutlined, CloseCircleOutlined} from "@ant-design/icons";

interface IStudentCardProps extends RouteComponentProps {
    student: StudentDetailsDto
}

@observer
export class StudentDetailsCard extends React.Component<IStudentCardProps, any> {

    routeToStudentDetails = () => {
        this.props.history.push(StudentDetailsScene.route.pathFormat(this.props.student!.studentUserId!))
    }
    @computed get student(){
        return this.props.student!
    }

    render() {
        return <Card style={{marginTop: 8}} className={'mouse-hover'} onClick={this.routeToStudentDetails}>
            <Row>
                <Col style={{marginRight: 12}} ><Avatar size={80} shape={'circle'} src={ImageUtils.UrlOrImageNotFountUrl(this.student.imageUrl)} alt={ImageUtils.ImageNotFountUrl}/></Col>
                <Col span={12}>
                    <div><Typography.Title level={5}>{`${this.student.name?.lastName} ${this.student.name?.firstName} ${this.student.name?.middleName}`}</Typography.Title></div>
                    <div>Ученик</div>
                </Col>
            </Row>
            <div style={{marginTop: 15}}>
                <Row>
                    <Col span={10} >
                        <PhoneOutlined/> +7{this.student.studentPhone}
                    </Col>
                    {this.student.lastActivityTime === null ? 
                        <Col span={14} style={{textAlign: 'right'}}><CloseCircleOutlined className="without-mobile" /> Без МП</Col> 
                    : null}
                </Row>
                <Row gutter={[15, 15]}>
                    <Col span={10}>
                        <div><FieldNumberOutlined/> Вождений: {this.student.scheduledTalonsCount}/{this.student.purchasedTalonsCount}</div>
                    </Col>
                    <Col span={14} style={{textAlign: 'right'}}>
                        <div><AuditOutlined /> {this.student.drivingCategory?.name}</div>
                    </Col>
                </Row>
            </div>
        </Card>;
    }
}

